import { generateAlphaNumeric } from './generateAlphaNumeric';

export const FIREBASE_ID_LENGTH = 20;

export const generateFirebaseId = () => {
  return generateAlphaNumeric(FIREBASE_ID_LENGTH);
};
